__turbopack_context__.v({
  "breadcrumbContainer": "Breadcrumb-module__3e-AXW__breadcrumbContainer",
  "breadcrumbItem": "Breadcrumb-module__3e-AXW__breadcrumbItem",
  "breadcrumbLink": "Breadcrumb-module__3e-AXW__breadcrumbLink",
  "breadcrumbList": "Breadcrumb-module__3e-AXW__breadcrumbList",
  "breadcrumbWrapper": "Breadcrumb-module__3e-AXW__breadcrumbWrapper",
  "currentPage": "Breadcrumb-module__3e-AXW__currentPage",
  "pageH1": "Breadcrumb-module__3e-AXW__pageH1",
  "pageH2": "Breadcrumb-module__3e-AXW__pageH2",
  "separator": "Breadcrumb-module__3e-AXW__separator",
  "spacer": "Breadcrumb-module__3e-AXW__spacer",
  "underH2": "Breadcrumb-module__3e-AXW__underH2",
});
